import api from './api';

const BASE_PATH = '/batch_generations';

/**
 * Cliente da API de pedidos de geração de batch via IA.
 * Backend em backend/app/controllers/api/v1/batch_generations_controller.rb.
 */
export const batchGenerationsApi = {
  index: () => api.get(BASE_PATH),
  show: id => api.get(`${BASE_PATH}/${id}`),

  // body: { password, generator_model, prompt_version, reasoning_effort,
  //         descriptor_codes: [], per_descriptor: 1, alternatives_count: 4|5 }
  create: payload => api.post(BASE_PATH, payload),

  // Cancela um batch em andamento. delete_generated=true remove as
  // questões já geradas (via paranoia soft delete) por este batch.
  cancel: (id, { deleteGenerated = false } = {}) =>
    api.post(`${BASE_PATH}/${id}/cancel`, { delete_generated: deleteGenerated })
};

export default batchGenerationsApi;
